import { notification } from 'antd';

const Notification = (type, message, description) => {
  notification[type]({
    message: message || '',
    description: description || '',
    top: 0,
  });
};

export default Notification;
